<template>
  <BasePaymentModal :name="name" @onProceed="emit('onProceed')">
    <template #title>
      {{ title }}
    </template>
    <template #description>
      {{ t('paymentErrorsModals.paid.description') }}
    </template>
    <template #buttonText>
      {{ t('paymentErrorsModals.paid.proceedToOrder') }}
    </template>
  </BasePaymentModal>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import BasePaymentModal from './BasePaymentModal.vue';

  const props = defineProps<{
    name: string;
    isSurcharge?: boolean;
  }>();

  const emit = defineEmits<{ onProceed: [] }>();

  const { t } = useI18n();
  const title = computed(() =>
    props.isSurcharge
      ? t('paymentErrorsModals.paid.surchargeTitle')
      : t('paymentErrorsModals.paid.title'),
  );
</script>

<i18n src="../config/locales.json"></i18n>
